export default __webpack_public_path__ + "static/media/tray.3deb7c75.jpg";